import { handleError } from "../utils/handleError";

// A failed request is logged with this curl (fpFetch -> handleError), and the
// log leaves the machine. Credentials never go with it: a bearer token, and
// the body fields that carry a session token or a one-time code (the identity
// call's `stytchSession`, the client environment's exchange `code` and the
// `token` it returns). In the client environment that token is a live
// credential into a client's organization (#10718).
const REDACTED = "<redacted>";
const SECRET_HEADERS = new Set(["authorization"]);
const SECRET_BODY_FIELDS = new Set(["stytchSession", "token", "code"]);

function redactBody(bodyData) {
  if (typeof bodyData !== "string") return bodyData;
  let parsed;
  try {
    parsed = JSON.parse(bodyData);
  } catch {
    return bodyData;
  }
  if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
    return bodyData;
  }
  const safe = { ...parsed };
  for (const key of Object.keys(safe)) {
    if (SECRET_BODY_FIELDS.has(key) && safe[key] != null) safe[key] = REDACTED;
  }
  return JSON.stringify(safe);
}

function generateCurl(url, options = {}) {
  try {
    let curlCommand = `curl '${url}'`;

    // Method
    if (options.method) {
      curlCommand += ` -X ${options.method}`;
    }

    // Headers
    if (options.headers) {
      Object.entries(options.headers).forEach(([key, value]) => {
        const shown = SECRET_HEADERS.has(key.toLowerCase()) ? REDACTED : value;
        curlCommand += ` -H '${key}: ${shown}'`;
      });
    }

    // Body
    if (options.body) {
      // Assuming the body is a stringifiable object or already a string.
      // For more complex scenarios, additional handling might be required.
      let bodyData = options.body;
      // Attempt to handle JSON body by stringifying if it appears to be an object
      if (typeof bodyData === "object") {
        try {
          bodyData = JSON.stringify(bodyData);
          // Add a Content-Type header if not already present
          if (!options.headers || !options.headers["Content-Type"]) {
            curlCommand += " -H 'Content-Type: application/json'";
          }
        } catch (error) {
          console.warn("Could not stringify body:", error);
        }
      }
      curlCommand += ` --data '${redactBody(bodyData)}'`;
    }

    return curlCommand;
  } catch (error) {
    handleError({
      error,
      location: "L0096226 generateCurl function",
    });
    return null;
  }
}

export default generateCurl;
